import { createContext, useContext, useEffect, useReducer, useRef, useState } from "react";
import reducer from '../reducer/ChatReducer'
import axios from "axios";
import {io} from 'socket.io-client'





const ChatAppContex=createContext()

const initialState={
    
    Search:"",
    chatData:'',
    
}

const ChatProvider=({children})=>{

  const[state,dispatch]=useReducer(reducer,initialState)


   
 const socket = useRef()

 useEffect(()=>{
    socket.current=io('https://socket-la43.onrender.com')
 },[])



 const[UserData,setUserData]=useState([])

 const[FilterData,setFilterData]=useState([])

 const[login,setlogin]=useState('')

 const[Convesation,setConvesation]=useState('')

 const[PersonData,setPersonData]=useState({})

 const[ActiveUser,SetActiveUser]=useState([])

//  const[Message,setMessage]=useState([])

const[te,Sette]=useState(false)







  const fetchData=async()=>{
    try {
        const res= await fetch('https://whatsup-6v48.onrender.com/allUser')
        const data= await res.json()
        // dispatch({type:"ADD_USER",payload:data.data})
         setUserData(data.data)
         setFilterData(data.data)
        // dispatch({type:"ADD_USER_INFILTER",payload:data.data})

    } catch (error) {
        console.log(error)  
    }
}


useEffect(()=>{
   fetchData()
},[login])





  const loginData=(data)=>{
   // dispatch({type:"LOGIN_DATA",payload:data})
    setlogin(data)
 }

 const SetActiveUsers=(data)=>{
     SetActiveUser(data)
  }
 
 const personData=(data)=>{
   // dispatch({type:"ADD_PERSON_DATA",payload:data})
    setPersonData(data)
 }






 const ConverSationData= async(idData)=>{

    const url='https://whatsup-6v48.onrender.com/getConversatinId'

    try {
        await axios.post(url,idData)
        .then((res)=>{
         // console.log(res.data.data)
          let data=res.data.data
         // dispatch({type:"CONVERSATION_DATA",payload:data})
          setConvesation(data)
         // ConverSationData(res.data.data)
          
        })
        .catch((res)=>{
            console.log(res.data.msg)
        })
    } catch (error) {
        console.log(error)
    }
 }



//  const SetMessage= async(idd)=>{
//   // dispatch({type:"MESSAGE_DATA",payload:idd})
//    setMessage(idd)       
//  }







    return(
        <ChatAppContex.Provider value={{
            ...state,
            loginData,
            personData,
            ConverSationData,
           
            socket,
            SetActiveUsers,
            ActiveUser,
            UserData,
            FilterData,
            login,
            PersonData,
            Convesation,
            te,
            Sette,
           

        }}>
            {children}
        </ChatAppContex.Provider>
    )
}





// usecustomhook

const useChatContex=()=>{


    return(
        useContext(ChatAppContex)
    )
}


export {useChatContex,ChatProvider,ChatAppContex}